import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox']

  connect () {
    this.toggleChecked = true
  }

  toggleAll () {
    this.checkboxTargets.forEach(element => {
      element.checked = this.toggleChecked
    })
    this.toggleChecked = !this.toggleChecked
    this.updateDisabledElements()
  }

  updateDisabledElements () {
    const submitButtons = document.querySelectorAll('.btn-submit')
    const checkedBoxes = Array.from(this.checkboxTargets).filter(item => item.checked)
    if (checkedBoxes.length >= 1) {
      submitButtons.forEach(element => {
        element.removeAttribute('disabled')
      })
    } else {
      submitButtons.forEach(element => {
        element.setAttribute('disabled', 'disabled')
      })
    }
  }

  exportFacilitiesCsv () {
    this.submitFacilityIds('/admin/company/facilities_csv', this.fetchFacilityIds())
  }

  createPostingInfoMail () {
    this.submitFacilityIds('/admin/nursing_facility/mails/create_posting_information_mail', this.fetchFacilityIds())
  }

  fetchFacilityIds () {
    const facilityIds = Array.from(this.checkboxTargets).filter(item => item.checked).map(item => item.value)
    return { facility_ids: facilityIds }
  }

  submitFacilityIds (path, facilityIds) {
    const form = document.createElement('form')
    form.action = path
    form.method = 'get'
    form.target = '_blank'
    const input = document.createElement('input')
    input.value = JSON.stringify(facilityIds)
    input.type = 'hidden'
    input.name = 'facility_ids'
    form.appendChild(input)
    document.body.appendChild(form)
    form.submit()
  }

  toHref (event) {
    event.preventDefault()
    const href = event.currentTarget.dataset.href
    window.location.href = href
  }
}
